import {Component, OnDestroy, OnInit} from '@angular/core';
import {
    MxConfirmDialogComponent
} from 'mx-core';
import {MxButtonModel} from '../../../../../../../mx-core/src/lib/modules/mx-button/components/mx-button.model';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';
import {Subject} from 'rxjs';
import {PrlAuthenticationService} from '../../../../shared/services/prl-authentication.service';
import {
    PrlTermsAndConditionsPageService
} from '../../services/terms-and-conditions-page/prl-terms-and-conditions-page.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'prl-terms-and-condition-page',
    templateUrl: './prl-terms-and-conditions-page.component.html',
    standalone: false,
    styleUrls: ['./prl-terms-and-conditions-page.component.scss']
})

export class PrlTermsAndConditionsPageComponent implements OnInit, OnDestroy {
    private _destroy$$: Subject<null> = new Subject<null>();
    private isTcAccepted: boolean = false;
    submitButton: MxButtonModel;
    tcCheckbox: boolean = false;
    contentHtml: string = null;

    constructor(private languageService: PrlLanguageService,
                protected authService: PrlAuthenticationService,
                private dialog: MatDialog,
                private router: Router,
                private termsAndConditionsPageService: PrlTermsAndConditionsPageService) {

    }

    ngOnInit(): void {
        this.termsAndConditionsPageService.getContent().subscribe(resp => {
                this.contentHtml = resp;
                if (this.authService.token) {
                    this.isTcAccepted = JSON.parse(localStorage.getItem('isTcAccepted'));
                }

                if (!this.isTcAccepted && this.authService.token) {
                    this.openDialog();
                }
            }
        )

        this.submitButton = {
            label: () => this.getLabel('label.submit'),
            permission: 'all',
            tooltip: () => this.getLabel('label.submit'),
            className: 'mxs-button--primary',
            clickHandler: () => this.submitTermsAndConditions()
        };
    }

    submitTermsAndConditions() {
        if (this.tcCheckbox) {
            this.termsAndConditionsPageService.acceptLastVersion().subscribe(resp => {
                    localStorage.setItem('isTcAccepted', JSON.stringify(resp));
                    this.router.navigateByUrl('/dashboard');
                }
            );
        } else {
            this.openDialog();
        }
    }

    isTcNotAccepted(): boolean {
        return JSON.parse(localStorage.getItem('isTcAccepted')) === false;
    }

    getLabel(label: string): string {
        return this.languageService.getLabel(label);
    }

    private openDialog() {
        this.dialog.open(MxConfirmDialogComponent, {
            width: '30%',
            panelClass: 'mx-dialog-panel-class',
            data: {
                type: 'warn',
                isAlert: true,
                title: this.getLabel('label.terms.and.conditions.popup.header'),
                message: this.getLabel('label.terms.and.conditions.popup.message'),
                okLabel: this.getLabel('label.continue')
            }
        }).afterClosed()
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

}
